module.exports = __webpack_public_path__ + "img/pagination4-icon.b53728e4.png";